import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../layout.css";

import logo1 from "../../Asserts/Images/levon-techno_logo.jpg";
import { FiChevronDown, FiChevronUp,FiUsers,FiUserPlus } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import { FaUser, FaFileAlt, FaCommentDots } from "react-icons/fa";
import { IoIosHelpCircle } from "react-icons/io";
import { FaSackDollar } from "react-icons/fa6";
import { IoLocationOutline, IoMenu } from "react-icons/io5";
import { MdOutlineDashboard, MdOutlineVerifiedUser } from "react-icons/md";
import { LuBuilding2 } from "react-icons/lu";
import { IoNotificationsOutline } from "react-icons/io5";
import { AiOutlineSafety } from "react-icons/ai";
import { TbReceiptTax, TbScanEye } from "react-icons/tb";
import { CiCircleQuestion } from "react-icons/ci";
import { IoSettingsOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { GoShieldX } from "react-icons/go";
import { LuNotebookPen } from "react-icons/lu";

function SidebarAdmin() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const location = useLocation();
  const isCertificationActive =
  location.pathname.startsWith("/certification") ||
  location.pathname.startsWith("/addnewcertification") ||
  location.pathname.startsWith("/view-certification") ||
  location.pathname.startsWith("/edit-certification");


    const isProformaActive =
  location.pathname.startsWith("/proforma-invoice") ||
  location.pathname.startsWith("/add-proforma-invoice") ||
  location.pathname.startsWith("/edit-proforma-invoice")

  const isCompaniesActive =
  location.pathname.includes("/companies") ||
  location.pathname.startsWith("/company-details/")||
location.pathname.startsWith("/view-invoice-page") ;

   const isActiveServelliance=
   location.pathname.startsWith("/survelliance-audit-one") ||
    location.pathname === "/remainder-page";
   
  const isActiveSecondServelliance=
   location.pathname.startsWith("/second-survelliance-audit") ||
    location.pathname === "/second-survelliance-audit-remainder";

    const isActiveTaxInvoices=
    location.pathname.startsWith("/tax-invoice") ||
    location.pathname === "/add-tax-invoice" ||
    location.pathname.startsWith("/edit-tax-invoice") ||
    location.pathname.startsWith ("/add-initial-tax-invoice");

  const menuSections = {
    dashboard: [
      {
        id: "dashboard",
        label: "Dashboard",
        to: "/dashboard",
        icon: (
          <span className="sidebar-icon-bg">
            <MdOutlineDashboard className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "companies",
        label: "Companies",
        to: "/companies",
        icon: (
          <span className="sidebar-icon-bg">
            <LuBuilding2 className="sidebar-icon" size={24} />
          </span>
        ),
      },
       {
        id: "proforma-invoice",
        label: "Proforma Invoices",
        to: "/proforma-invoice",
        icon: (
          <span className="sidebar-icon-bg">
            <TbReceiptTax className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "invoice",
        label: "Tax Invoices",
        to: "/tax-invoice",
        icon: (
          <span className="sidebar-icon-bg">
            <TbReceiptTax className="sidebar-icon" size={24} />
          </span>
        ),
      },
      // {
      //   id: "individual-trainee",
      //   label: "Individual Trainee",
      //   to: "/individual-trainee-page",
      //   icon: (
      //     <span className="sidebar-icon-bg">
      //       <AiOutlineSafety className="sidebar-icon" size={24} />
      //     </span>
      //   ),
      // },
      // {
      //   id: "1st-surveillance-audits",
      //   label: "1st Surveillance Audits",
      //   to: "/survelliance-audit-one",
      //   icon: (
      //     <span className="sidebar-icon-bg">
      //       <TbScanEye className="sidebar-icon" size={24} />
      //     </span>
      //   ),
      // },
      // {
      //   id: "2nd-surveillance-audits",
      //   label: "2nd Surveillance Audits",
      //   to: "/second-survelliance-audit",
      //   icon: (
      //     <span className="sidebar-icon-bg">
      //       <TbScanEye className="sidebar-icon" size={22} />
      //     </span>
      //   ),
      // },
      // {
      //   id: "expired-certification",
      //   label: "Expired Certifications",
      //   to: "/expired-certifications",
      //   icon: (
      //     <span className="sidebar-icon-bg">
      //       <GoShieldX className="sidebar-icon" size={24} />
      //     </span>
      //   ),
      // },
      {
        id: "stanadardList",
        label: "Standards",
        to: "/standards-list",
        icon: (
          <span className="sidebar-icon-bg">
            <FiUsers className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "agents",
        label: "Agents",
        to: "/agents-page",
        icon: (
          <span className="sidebar-icon-bg">
            <FiUsers className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "managers",
        label: "Managers",
        to: "/managers-page",
        icon: (
          <span className="sidebar-icon-bg">
            <FiUsers className="sidebar-icon" size={24} />
          </span>
        ),
      },
      {
        id: "vendors",
        label: "Vendors",
        to: "/vendors-page",
        icon: (
          <span className="sidebar-icon-bg">
            <FiUsers className="sidebar-icon" size={24} />
          </span>
        ),
      },
       {
        id: "pendingPayments",
        label: "Pending Payments",
        to: "/pending-payments-list",
        icon: (
          <span className="sidebar-icon-bg">
            <FiUsers className="sidebar-icon" size={24} />
          </span>
        ),
      },
      // {
      //   id: "users",
      //   label: "Add Users",
      //   to: "/usertable-page",
      //   icon: (
      //     <span className="sidebar-icon-bg">
      //       <FiUserPlus className="sidebar-icon" size={22} />
      //     </span>
      //   ),
      // },
      // {
      //   id: "notifications",
      //   label: "Notifications",
      //   to: "/notification-table/notification",
      //   icon: (
      //     <span className="sidebar-icon-bg">
      //       <IoNotificationsOutline className="sidebar-icon" size={22} />
      //     </span>
      //   ),
      // },
      // {
      //   id: "reports",
      //   label: "Reports",
      //   to: "/reports-page",
      //   icon: (
      //     <span className="sidebar-icon-bg">
      //       <LuNotebookPen  className="sidebar-icon" size={22} />
      //     </span>
      //   ),
      // },
      {
        id: "TDS",
        label: "TDS Reports",
        to: "/tds-reports-table",
        icon: (
          <span className="sidebar-icon-bg">
            <LuNotebookPen  className="sidebar-icon" size={22} />
          </span>
        ),
      },
      {
        id: "gst",
        label: "GST Reports",
        to: "/gst-reports-table",
        icon: (
          <span className="sidebar-icon-bg">
            <LuNotebookPen  className="sidebar-icon" size={22} />
          </span>
        ),
      },
      {
        id: "bank-details",
        label: "Bank Details",
        to: "/bank-details-page",
        icon: (
          <span className="sidebar-icon-bg">
            <LuNotebookPen  className="sidebar-icon" size={22} />
          </span>
        ),
      },
    ],
    others: [
      // {
      //   id: "reports",
      //   label: "Reports",
      //   to: "/reports-analytics/customer-growth-reports",
      //   icon: (
      //     <span className="sidebar-icon-bg">
      //       <CiCircleQuestion className="sidebar-icon" size={22} />
      //     </span>
      //   ),
      // },
      {
        id: "settings",
        label: "Settings",
        to: "/settings",
        icon: (
          <span className="sidebar-icon-bg">
            <IoSettingsOutline className="sidebar-icon" size={22} />
          </span>
        ),
      },
      {
        id: "users",
        label: "Users",
        to: "/users",
        icon: (
          <span className="sidebar-icon-bg">
            <IoSettingsOutline className="sidebar-icon" size={22} />
          </span>
        ),
      },
    ],
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMenu = (menu) => {
    setExpandedMenu(expandedMenu === menu ? null : menu);
  };

  return (
    <>
      {/* Mobile toggle button */}
      <button
        className="toggle-btn-header d-block d-sm-block d-md-block d-lg-none"
        onClick={toggleSidebar}
      >
        <IoMenu style={{ width: "30px", height: "30px", position: "fixed" }} />
        <span className="visually-hidden">Toggle sidebar</span>
      </button>

      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <aside className={`sidebar-content ${isSidebarOpen ? "open" : ""}`}>
          <div className="sidebar-header">
            <img
              src={logo1}
              alt="Logo"
              className="sidebar-logo"
              onClick={() => navigate("/dashboard")}
            />
           
            <button
              className="close-btn menu-close-button-response"
              onClick={toggleSidebar}
            >
              <IoMdClose />
            </button>
          </div>

          <nav className="sidebar-nav mt-4">
            {/* Top Menu */}
            <div className="sidebar-nav-links sidebar-nav-top">
              <ul>
                {menuSections.dashboard.map((menuItem) => (
                  <li key={menuItem.id}>
                    <NavLink
                      to={menuItem.to}
                      className={({ isActive }) => {
                        const isCert =
                          menuItem.id === "certifications" &&
                          isCertificationActive;
                          const isIndiviual = menuItem.id === "proforma-invoice" && isProformaActive;
                          const isCerttwo = menuItem.id === "1st-surveillance-audits" && isActiveServelliance;
                          const isCertthree = menuItem.id === "2nd-surveillance-audits" && isActiveSecondServelliance;
                          const isCertFour = menuItem.id === "companies" && isCompaniesActive;
                          const isCertFive = menuItem.id === "invoice" && isActiveTaxInvoices;

                        return isActive || isCert || isCerttwo || isCertthree || isCertFour || isIndiviual || isCertFive
                          ? "nav-link active-nav-links"
                          : "nav-link";
                      }}
                      onClick={() => {
                        if (isSidebarOpen) toggleSidebar();
                      }}
                    >
                      {menuItem.icon}
                      {menuItem.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Bottom Menu */}
            <div className="sidebar-nav-links sidebar-nav-bottom">
              <ul>
                {menuSections.others.map((menuItem) => (
                  <li key={menuItem.id}>
                    <NavLink
                      to={menuItem.to}
                      {...(menuItem.to === "/" ? { end: true } : {})}
                      className={({ isActive }) =>
                        isActive ? "nav-link active-nav-links" : "nav-link"
                      }
                      onClick={() => {
                        if (isSidebarOpen) toggleSidebar();
                      }}
                    >
                      {menuItem.icon}
                      {menuItem.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </aside>
      </div>
    </>
  );
}

export default SidebarAdmin;
